import React from 'react'
import ContentHeader from '../../containers/ContentHeader'
import { NewPatientForm } from '../../containers/Forms'
import EcgLoader from '../../containers/EcgLoader'
import { HEADER_HEIGHT, BOTTOM_PADDING, UNASSIGNED_ORDERING_PHYSICIAN_OPTION } from '../../constants'
import styles from './AddNewPatient.css'
import { needToBustCache } from '../../store/appReducer'
import { checkRpmFeatureEnabled } from 'configs'
import ContentWithNavigationSidebar from 'legacy/layouts/ContentWithNavigationSidebar'
import AccessDeniedContent from 'views/components/AccessDeniedContent/AccessDeniedContent'
import { FormattedMessage } from 'react-intl'

class AddNewPatient extends React.Component {
  state = {
    innerHeight: 0,
  }

  UNSAFE_componentWillMount() {
    const {
      dataLastUpdated,
      getAddNewPatientData,
    } = this.props

    getAddNewPatientData(needToBustCache(dataLastUpdated))

    window.addEventListener('resize', this.handleResize)
    this.setState({
      innerHeight: window.innerHeight,
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.setState({
      innerHeight: window.innerHeight,
    })
  }

  handleOnPrescribeCheckboxClick = e => {
    const {
      prescribeKardia,
    } = this.state

    this.setState({
      prescribeKardia: !prescribeKardia,
    })
  }

  render() {
    const {
      dataIsFetching,
      dataLastUpdated,
      getAddNewPatientData,
      physicians,
      handleOnNewPatientFormSubmit,
      anyTouched,
      me,
      medantaUHIDValidation,
    } = this.props
    const {
      innerHeight,
    } = this.state

    const initialValues = {
      orderingPhysician: UNASSIGNED_ORDERING_PHYSICIAN_OPTION,
    }

    const contentHeight = innerHeight - HEADER_HEIGHT - BOTTOM_PADDING

    if (!checkRpmFeatureEnabled(me)) {
      return (
        <div data-page="add-new-patienth" className={styles.addNewPatient}>
          <AccessDeniedContent
            title={<FormattedMessage id="button.add_patient" />}
          />
        </div>
      )
    }

    return (
      <div data-page="add-new-patient" className={styles.addNewPatient}>
        <ContentHeader
          isLoading={dataIsFetching}
          lastUpdated={dataLastUpdated}
          handleOnRefreshClick={() => getAddNewPatientData(true)}
          text={<FormattedMessage id="button.add_patient" />}
          me={me}
        />
        {!dataIsFetching
          ? (
            <div
              className={styles.formWrapper}
              style={{
                height: contentHeight,
              }}
            >
              <div className={styles.formTop}>
                <h2 className={styles.formTitle}><FormattedMessage id="heading.Patient_Information" /></h2>
                <NewPatientForm
                  physicians={physicians}
                  onSubmit={handleOnNewPatientFormSubmit}
                  initialValues={initialValues}
                  isSubmitting={anyTouched && dataIsFetching}
                  medantaUHIDValidation={medantaUHIDValidation}
                  me={me}
                />
              </div>
            </div>
          )
          : (
            <div
              className={styles.contentWrapper}
              style={{
                height: contentHeight,
              }}
            >
              <EcgLoader />
            </div>
          )
        }
      </div>
    )
  }
}

export default AddNewPatient



// WEBPACK FOOTER //
// ./src/legacy/pages/AddNewPatient/AddNewPatient.jsx